import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[pgsPgsNumberFilter]'
})
export class PgsNumberFilterDirective {

  regexStr = '^[0-9.]+$';

  constructor(private el: ElementRef) { }

  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
    return new RegExp(this.regexStr).test(event.key);
  }
}
